import { AppSettingsService } from "../../../services/appsettings.service";
import { PaysService } from "../../../services/pays.service";
import { SproToasterService } from "../../../sproLib/spro/services/spro-toaster/spro-toaster.service";
import { Component } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { varGlobal } from "../../varGlobal";

@Component({
  selector: "app-pageProfilEntreprise",
  styleUrls: ["./pageProfilEntreprise.component.scss"],
  templateUrl: "./pageProfilEntreprise.component.html"
})
export class cls_profilEntreprise {
  /* ###########################################  VARIABLES  #######################################################*/

  /** Nom de la page afin de gérer la traduction */
  public w_titre_trad = "pageProfilEntreprise.";
  /** Flag de chargement */
  public f_loading: boolean = true;
  /** Loading sur ouverture de la page */
  public f_loadingCharge = true;

  /** Masquer le libellé de titre Etape */
  public f_masqueEtape: boolean = false;

  /** Formulaire des données */
  public form_profil: FormGroup;

  /** Langue utilisé (pour affichage du Siret) */
  public w_lang: string = "";

  /** Liste des Pays (données de la combo) */
  public h_listPays: Array<any>;
  /** Pays pour init combo */
  public h_selectedPays: { paysId: number; despay: string } = null;
  /** Pays en cours de visualisation */
  public i_pays: number = null;

  /* ###########################################  CONSTRUCTEUR  ####################################################*/

  /**
   * Constructeur
   */
  constructor(
    public s_appsettings: AppSettingsService,
    public s_translate: TranslateService,
    public s_pays: PaysService,
    public s_toaster: SproToasterService,
    public fb: FormBuilder,
    public s_global: varGlobal
  ) {
    //Dans le cas ou on charge l'application par cette page et non par le login, on charge la langue par défaut du navigateur
    if (!this.s_translate.currentLang) {
      //Initialisation de la langue a afficher
      this.s_appsettings.proc_initLangue();
    }

    this.w_lang = this.s_translate.currentLang;

    //Formulaire avec les inputs
    this.form_profil = this.fb.group({
      raisonsocialetiers: [, [Validators.required, Validators.maxLength(50)]],
      detailadr: [, [Validators.required, Validators.maxLength(250)]],
      codepostaladr: [, [Validators.required, Validators.maxLength(15)]],
      villeadr: [, [Validators.required, Validators.maxLength(50)]],
      telephoneinterloc: [
        ,
        [
          Validators.required,
          Validators.minLength(7),
          Validators.maxLength(25),
          Validators.pattern("[0-9 .#()'+-]+")
        ]
      ],
      faxinterloc: [, [Validators.maxLength(30)]],
      ceetiers: [, [Validators.required, Validators.maxLength(15)]],
      sirettiers: [, [Validators.maxLength(14)]]
    });

    // Exécute la boucle de chargement
    this.proc_boucle();
  }

  /* ###########################################  FONCTIONS  #######################################################*/

  /**
   * Chargement des données de la base
   * mis dans une fonction avec timeout pour le cas de rechargement de page
   * où le appSettings est chargé en retard (Pb de pathAPI pas initialisé)
   */
  public proc_boucle = function() {
    if (this.s_global.pathAPI === "pathAPI") {
      setTimeout(() => {
        this.proc_boucle();
      }, 1000);
      return;
    }

    //Recuperation de la liste des pays pour le dropdown
    this.s_pays.proc_getAll().subscribe(
      data => {
        this.h_listPays = data;
        this.f_loadingCharge = false;
      },
      error => {
        this.s_appsettings.proc_gestionErreur(error);
        this.f_loadingCharge = false;
      }
    );
  };

  /**
   * Evénements sur changement de valeur de combo tiers
   */
  public proc_paysChange(value): void {
    if (value == null) this.i_pays = null;
    else this.i_pays = value.paysId;
  }

  /**
   * Affectation des valeurs
   */
  public proc_setData(h_data: any, f_masqueEtape: boolean): void {
    if (h_data == null) this.form_profil.reset([]);
    else this.form_profil.reset(h_data);

    this.f_masqueEtape = f_masqueEtape;

    if (h_data != null) {
      this.i_pays = h_data["paysId"];
      this.h_selectedPays = { paysId: this.i_pays, despay: "" };
    }

    this.f_loading = false;
  }

  /**
   * Test du formulaire et retourne les valeurs
   */
  public proc_getData(): any {
    //Ajout de la valeur de la combobox pays au formulaire
    if (this.i_pays == null) {
      this.s_toaster.proc_toastTradError(this.w_titre_trad + "msg_Pays");
      return null;
    }

    //Verifications de la validité des Validators (format /required)
    if (this.form_profil.status === "INVALID") {
      this.s_toaster.proc_toastTradError("pageProfil.msg_FormInval");
      return null;
    }

    const h_data = this.form_profil.value;
    h_data["paysId"] = this.i_pays;

    return h_data;
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/shared/components/pageProfilEntreprise/pageProfilEntreprise.component.ts